export default "<article *ngIf=\"done\" [innerHTML]=\"done\"></article>\n"